import PowerSettingsNewSharpIcon from '@mui/icons-material/PowerSettingsNewSharp'
import { Box, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import React from 'react'

import { Avatar, IconButton } from '../../atoms'

const Row = styled('div')(() => ({
  padding: '20px',
  display: 'flex',
  alignItems: 'center'
}))

interface UserProps {
  name: string
  imageSrc?: string
  role: string
}

interface UserCardProps {
  user?: UserProps
  open?: boolean
  logout?: () => void
  onClick?: () => void
}

const UserCard: React.FC<UserCardProps> = ({
  user = { name: 'Anonymous', role: 'Admin' },
  open = true,
  logout,
  onClick
}) =>
  open ? (
    <Row>
      <Avatar onClick={onClick} src={user.imageSrc || undefined} alt={user.name || ''} />
      <Box sx={{ ml: 2 }}>
        <Typography
          variant="h6"
          sx={{
            maxWidth: '200px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            color: 'common.white'
          }}
        >
          {user?.name}
        </Typography>
        <Typography variant="subtitle2" sx={{ color: 'grey.200' }}>
          {user?.role}
        </Typography>
      </Box>
      {logout && (
        <Box sx={{ display: 'flex', width: '100%', justifyContent: 'flex-end' }}>
          <IconButton icon={<PowerSettingsNewSharpIcon />} onClick={logout} size="large" />
        </Box>
      )}
    </Row>
  ) : (
    <Row sx={{ flexDirection: 'column', alignItems: 'center', gap: 1 }}>
      <Avatar onClick={onClick} src={user?.imageSrc || undefined} alt={user?.name || ''} small />
      {logout && (
        <Box
          sx={{
            '& .MuiIconButton-root': { padding: '6px' },
            '& .MuiSvgIcon-root': { fontSize: '1.125rem' }
          }}
        >
          <IconButton icon={<PowerSettingsNewSharpIcon />} onClick={logout} />
        </Box>
      )}
    </Row>
  )

export default UserCard
